<template>
  <el-form-item
    :class="{ desktop: isDesktop }"
    :label-width="labelWidth"
    label="Device"
  >
    <el-select
      v-model="value"
      multiple
      :disabled="disabled"
      placeholder="All"
      @update:modelValue="update"
    >
      <el-option
        v-for="item in options"
        :key="item.key"
        :label="item.label"
        :value="item.key"
      />
    </el-select>
  </el-form-item>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from 'vue'
import { Device, DeviceTypeLabel, DeviceTypeLabels } from '@/api/types'
import useResize from '@/hooks/useResize'

type DeviceEntry = {
  key: Device
  label: string
  disabled: boolean
}

export default defineComponent({
  name: 'DeviceSelector',
  props: {
    modelValue: {
      type: Array,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    labelWidth: {
      type: String,
      default: '150px'
    }
  },
  setup(props, context) {
    const value = ref(props.modelValue)

    const options = DeviceTypeLabels.map<DeviceEntry>(
      (deviceLabel: DeviceTypeLabel) => {
        return {
          key: deviceLabel.type_id,
          label: deviceLabel.label,
          disabled: false
        }
      }
    )

    const { isDesktop } = useResize()

    const update = (newValue: Array<Device>) => {
      context.emit('update:modelValue', newValue)
    }

    watch(
      () => props.modelValue,
      (newVal) => {
        value.value = newVal
      }
    )

    return { options, update, isDesktop, ref, value }
  }
})
</script>

<style lang="scss" scoped>
.el-select {
  width: 100%;
}
</style>
